import {ComponentProps, useContext} from 'react';
import {useDotComWordStreamer} from '../../Conversation/useDotcomWordStreamer';
import {DotComChatBubbleAnimationContext} from '../../Conversation/Log/useItemsDotCom';
import {TextBubble} from './TextBubble';
import {ChatBubbleDotCom} from './ChatBubbleDotCom';
import {TextBody} from './TextBody';

type Props = ComponentProps<typeof TextBubble> & {messageId?: string};

export const TextBubbleDotCom = ({
  body,
  background = 'neutral100',
  messageId,
  children,
}: Props) => {
  const {animatedMessageId, scaleAnimationDisabled, onAnimationFinished} =
    useContext(DotComChatBubbleAnimationContext);
  const animated = messageId === animatedMessageId;

  const wordStreamer = useDotComWordStreamer({
    text: body,
    disabled: !animated,
    onFinished: () => {
      if (animated) {
        onAnimationFinished();
      }
    },
  });

  const getBubbleAnimation = () => {
    if (!animated) {
      return 'disabled';
    }

    return scaleAnimationDisabled ? 'skip-scale' : 'all';
  };

  return (
    <ChatBubbleDotCom background={background} animation={getBubbleAnimation()}>
      {wordStreamer.textChunk ? (
        <TextBody body={wordStreamer.textChunk} background={background} />
      ) : null}
      {children}
    </ChatBubbleDotCom>
  );
};
